export const environment = {
    production: true,
    host: 'https://admin.dev.syrexcloud.com/api',
    ssl: false,
    appClientId: '2cc882b14ec743939f843a5ab560aa9c'
};
